import { h } from "preact";
import { RoutableProps, route } from "preact-router";
import { useState } from "preact/hooks";
import { OrderComposer } from "./OrderComposer";
import { createOrder, editOrder, ManufacturingOrder } from "../api/product-api";
import { SearchInStringExec } from "../utils";

export function OrderCreator(props: { id: string | number | undefined, orderTypes: string[], serialRegexes: SearchInStringExec[] }) {
    const [createdOrderId, setCreatedOrderId] = useState(0);

    const orderId = props.id ? parseInt(props.id.toString()) : null;

    return <div class="stella-bio-order-page">
        {!createdOrderId ? [
            <div class="order paper">
                <h1>{orderId ? "Edycja zestawienia" : "Tworzenie zestawienia"}</h1>
                <OrderComposer
                    commitTitle={orderId ? undefined : "Utwórz zestawienie"}
                    edit={!!orderId}
                    id={orderId ?? undefined}
                    orderTypes={props.orderTypes}
                    serialRegexes={props.serialRegexes}
                    onCommit={async (orderName, description, elementList, otherData) => {
                        let data: ManufacturingOrder;

                        if (!orderId) {
                            data = await createOrder(orderName, description, elementList, otherData);
                        }
                        else {
                            data = await editOrder(orderId, description, elementList, otherData);
                        }

                        setCreatedOrderId(data.id);
                    }}/>
            </div>
        ] : [
            <div class="ready">
                {orderId ? "Zestawienie zostało zmienione" : "Zestawienie zostało dodane"}
            </div>,
            <div class="ready-options">
                <button type="button" onClick={() => route(`/order/${createdOrderId}`, true)}>Podgląd zestawienia</button>
                <button type="button" class="secondary" onClick={() => history.back()}>Powrót</button>
            </div>
        ]}
    </div>;
}
